import AssignmentService from '../../services/assignment.service'
import { openNotificationWithIcon } from '../../utils/notification.helper'
import _, { isEmpty, isNumber } from 'lodash'
import AssignmentsService from '../../services/assignments.service'
import Routes from '../../constants/routes'
import { CLUSTER_X_ID, CLUSTER_Y_ID } from '../../constants/cluster-ids'
import { handleErrors } from '../../utils/request.helper'
import { isExcelAssignment } from '../../utils/assignment.helper'
import { ASSIGNMENT_PROCESSING_STATUSES } from '../../constants/assignment-processing-statuses'
import { PATTERN_TYPES } from '../../constants/pattern-types'
import { LLM_VERSIONS } from '../../constants/llm-versions'
import { setClientAssignmentLastModified, setServerAssignmentLastModified } from '../slices/assignment.slice'
import {
    COMPONENT_TAG,
    GROUP_TAG,
    PATTERN_TAG,
    VERSION_TAG,
    CONCEPTUAL_LABEL_TAG,
    ASSIGNMENT_TAG,
} from '../apis/utils/tags'
import { batch } from 'react-redux'
import { StatusCodes } from 'http-status-codes'
import { REVIEW_FILTERS } from '../../pages/assignment/sections/clusters/filters/ReviewFilters'
import { setPendingApprovalPatternId } from '../slices/pattern.slice'
import { submissionActions } from '../slices/submission.slice'
import { AssignmentSections } from '../../constants/assignment-sections'
import baseApi from '../apis/base.api'
import { GROUPING_CAP_TYPES } from '../../constants/grouping-cap-types'
import { PatternWarningLevels } from '../../constants/pattern-warning-levels'
import { assignmentApi } from '../apis/assignment.api'

/***************************************** INITIAL STATE ********************************************/
const INITIAL_FILTERS = {
    exactMatch: false,
    patterns: [],
    feedback: {
        missingPatternFeedback: false,
        missingGroupFeedback: false,
    },
    unitTests: [],
    type: {
        anonymousSubmissions: false,
    },
    properties: {
        isFlaky: false,
    },
    review: REVIEW_FILTERS.ALL,
}

export const INITIAL_DRAWER = {
    showDrawer: false,
    file: {
        content: null,
    },
    showQueryEditor: false,
    idOfPatternToChange: null,
}

const INITIAL_QUERY_TO_COMPARE = {
    label: '',
    value: '',
}

export const INITIAL_STATE = {
    assignment: {},
    clusters: [],
    filteredClusters: [],
    filters: INITIAL_FILTERS,
    isWaitingForClusters: false,
    isWaitingForAssignmentInfo: false,
    isWaitingForFiles: false,
    isWaitingForPatterns: false,
    isWaitingForSelectSubgroup: false,
    layers: [],
    versions: [],
    drawer: INITIAL_DRAWER,
    query: '',
    queryToCompare: INITIAL_QUERY_TO_COMPARE,
    regroup: true,
    confirmChangesMode: false,
    queryComparisonMode: false,
    showCreateVersionModal: false,
    showEditVersionModal: false,
    showCreateComponentModal: false,
    showEditComponentModal: false,
    showDiscoveryModal: false,
    showGradingModal: false,
    showEditPatternModal: false,
    showCreateSemanticPatternModal: false,
    showSubmissionsSummaryModal: false,
    showMoveSelectedFilesToAnotherGroupModal: false,
    patternsReportData: [],
    groupsUnitTestsReportData: null,
    unitTests: [],
    unitTestResults: [],
    isWaitingForUnitTestResults: false,
    editingPattern: null,
    semanticPatternDetails: null,
    descriptionsSuggestedBySemanticDiscovery: null,
    collapsedClusterIds: [],
}

/***************************************** ACTION TYPES *********************************************/
const reducerName = 'ASSIGNMENT_'
const actionTypes = {
    SET_ASSIGNMENT: `${reducerName}SET_ASSIGNMENT`,
    SET_CLUSTERS: `${reducerName}SET_CLUSTERS`,
    SET_FILTERED_CLUSTERS: `${reducerName}SET_FILTERED_CLUSTERS`,
    SET_INCLUDE_ANON_SUBMISSIONS_FILTER: `${reducerName}SET_INCLUDE_ANON_SUBMISSIONS_FILTER`,
    SET_EXACT_MATCH: `${reducerName}SET_EXACT_MATCH`,
    SET_PATTERN_FILTER: `${reducerName}SET_PATTERN_FILTER`,
    SET_MISSING_PATTERN_FEEDBACK_FILTER: `${reducerName}SET_MISSING_PATTERN_FEEDBACK_FILTER`,
    SET_MISSING_GROUP_FEEDBACK_FILTER: `${reducerName}SET_MISSING_GROUP_FEEDBACK_FILTER`,
    SET_UNIT_TESTS_FILTER: `${reducerName}SET_UNIT_TESTS_FILTER`,
    SET_IS_FLAKY_FILTER: `${reducerName}SET_IS_FLAKY_FILTER`,
    SET_REVIEW_FILTER: `${reducerName}SET_REVIEW_FILTER`,
    SET_IS_WAITING_FOR_CLUSTERS: `${reducerName}SET_IS_WAITING_FOR_CLUSTERS`,
    SET_IS_WAITING_FOR_ASSIGNMENT_INFO: `${reducerName}SET_IS_WAITING_FOR_ASSIGNMENT_INFO`,
    SET_IS_WAITING_FOR_FILES: `${reducerName}SET_IS_WAITING_FOR_FILES`,
    SET_IS_WAITING_FOR_PATTERNS: `${reducerName}SET_IS_WAITING_FOR_PATTERNS`,
    SET_IS_WAITING_FOR_SELECT_SUBGROUP: `${reducerName}SET_IS_WAITING_FOR_SELECT_SUBGROUP`,
    SET_LAYERS: `${reducerName}SET_LAYERS`,
    SET_VERSIONS: `${reducerName}SET_VERSIONS`,
    SET_SHOW_DRAWER: `${reducerName}SET_SHOW_DRAWER`,
    SET_DRAWER_FILE: `${reducerName}SET_DRAWER_FILE`,
    SET_SELECTED_TERMS: `${reducerName}SET_SELECTED_TERMS`,
    SET_QUERY: `${reducerName}SET_QUERY`,
    SET_QUERY_TO_COMPARE: `${reducerName}SET_QUERY_TO_COMPARE`,
    SET_REGROUP: `${reducerName}SET_REGROUP`,
    SET_SHOW_QUERY: `${reducerName}SET_SHOW_QUERY`,
    SET_ID_OF_PATTERN_TO_CHANGE: `${reducerName}SET_ID_OF_PATTERN_TO_CHANGE`,
    SET_CONFIRM_CHANGES_MODE: `${reducerName}SET_CONFIRM_CHANGES_MODE`,
    SET_QUERY_COMPARISON_MODE: `${reducerName}SET_QUERY_COMPARISON_MODE`,
    SET_SHOW_CREATE_VERSION_MODAL: `${reducerName}SET_SHOW_CREATE_VERSION_MODAL`,
    SET_SHOW_ADVANCED_EXPORT_SUBMISSIONS_MODAL: `${reducerName}SET_SHOW_ADVANCED_EXPORT_SUBMISSIONS`,
    SET_SHOW_EDIT_VERSION_MODAL: `${reducerName}SET_SHOW_EDIT_VERSION_MODAL`,
    SET_SHOW_CREATE_COMPONENT_MODAL: `${reducerName}SET_SHOW_CREATE_COMPONENT_MODAL`,
    SET_SHOW_EDIT_COMPONENT_MODAL: `${reducerName}SET_SHOW_EDIT_COMPONENT_MODAL`,
    SET_SHOW_DISCOVERY_MODAL: `${reducerName}SET_SHOW_DISCOVERY_MODAL`,
    SET_SHOW_GRADING_MODAL: `${reducerName}SET_SHOW_GRADING_MODAL`,
    SET_SHOW_EDIT_PATTERN_MODAL: `${reducerName}SET_SHOW_EDIT_PATTERN_MODAL`,
    SET_SHOW_CREATE_SEMANTIC_PATTERN_MODAL: `${reducerName}SET_SHOW_CREATE_SEMANTIC_PATTERN_MODAL`,
    SET_SHOW_EXPORT_GRADES_MODAL: `${reducerName}SET_SHOW_EXPORT_GRADES_MODAL`,
    SET_SHOW_MOVE_SELECTED_FILES_TO_ANOTHER_GROUP_MODAL: `${reducerName}SET_SHOW_MOVE_SELECTED_FILES_TO_ANOTHER_GROUP_MODAL`,
    SET_SIMILARITY_FUNCTIONS: `${reducerName}SET_SIMILARITY_FUNCTIONS`,
    SET_INITIAL_STATE: `${reducerName}SET_INITIAL_STATE`,
    SET_PATTERNS_REPORT_DATA: `${reducerName}SET_PATTERNS_REPORT_DATA`,
    SET_GROUPS_UNIT_TESTS_REPORT_DATA: `${reducerName}SET_GROUPS_UNIT_TESTS_REPORT_DATA`,
    SET_ASSIGNMENT_HIDE_GRADING: `${reducerName}SET_ASSIGNMENT_HIDE_GRADING`,
    SET_UNIT_TESTS: `${reducerName}SET_UNIT_TESTS`,
    SET_UNIT_TEST_RESULTS: `${reducerName}SET_UNIT_TEST_RESULTS`,
    SET_IS_WAITING_FOR_UNIT_TEST_RESULTS: `${reducerName}SET_IS_WAITING_FOR_UNIT_TEST_RESULTS`,
    SET_EDITING_PATTERN: `${reducerName}SET_EDITING_PATTERN`,
    SET_ID_OF_PATTERN_CREATED_BY_QUERY: `${reducerName}SET_ID_OF_PATTERN_CREATED_BY_QUERY`,
    SET_SEMANTIC_PATTERN_DETAILS: `${reducerName}SET_SEMANTIC_PATTERN_DETAILS`,
    SET_COLOR_ID_OF_CREATED_SEMANTIC_PATTERN_DETAILS: `${reducerName}SET_COLOR_ID_OF_CREATED_SEMANTIC_PATTERN_DETAILS`,
    SET_DESCRIPTIONS_SUGGESTED_BY_SEMANTIC_DISCOVERY: `${reducerName}SET_DESCRIPTIONS_SUGGESTED_BY_SEMANTIC_DISCOVERY`,
    SWITCH_CLUSTER_COLLAPSE: `${reducerName}SWITCH_CLUSTER_COLLAPSE`,
    SWITCH_ALL_CLUSTERS_COLLAPSE: `${reducerName}SWITCH_ALL_CLUSTERS_COLLAPSE`,
    SET_PATTERN_CRITERIA_FILTER: `${reducerName}SET_PATTERN_CRITERIA_FILTER`,
    SET_PATTERN_EXPANDED: `${reducerName}SET_PATTERN_EXPANDED`,
}

/******************************************** ACTIONS ***********************************************/
export const actions = {
    setAssignment: value => ({
        type: actionTypes.SET_ASSIGNMENT,
        payload: { value },
    }),
    fetchAssignmentInfo: (token, navigate) => async (dispatch, getState) => {
        let assignment
        if (isEmpty(getState().assignment.assignment)) dispatch(actions.setIsWaitingForAssignmentInfo(true))
        try {
            const getAssigmentResponse = await AssignmentService.getAssignment(token)
            assignment = {
                ...getState().assignment.assignment,
                ...getAssigmentResponse.data,
            }

            const serverLastModified = getState().assignmentSlice.serverAssignmentLastModified
            if (serverLastModified) {
                //to store serverAssignmentLastModified only on initial fetch
                dispatch(setClientAssignmentLastModified(assignment.current_version?.last_modified))
            } else {
                batch(() => {
                    dispatch(setClientAssignmentLastModified(assignment.current_version?.last_modified))
                    dispatch(setServerAssignmentLastModified(assignment.current_version?.last_modified))
                })
            }

            dispatch(actions.setAssignment(assignment))
        } catch (error) {
            if (error?.response?.status === StatusCodes.NOT_FOUND && navigate) {
                navigate(Routes.HOME)
            } else if (error?.response) {
                openNotificationWithIcon('warning', error.response.data.detail)
            } else {
                console.log(error)
            }
        }
        dispatch(actions.setIsWaitingForAssignmentInfo(false))
        return assignment
    },
    patchAssignment: (token, data) => async (dispatch, getState) => {
        await AssignmentService.patchAssignment(token, data)

        dispatch(actions.setAssignment({ ...getState().assignment.assignment, ...data }))

        openNotificationWithIcon('success', 'Saved successfully')
    },
    patchLinterConfig: (token, data) => async (dispatch, getState) => {
        await AssignmentService.patchLinterConfig(token, data)

        dispatch(actions.setAssignment({ ...getState().assignment.assignment, ...data }))

        openNotificationWithIcon('success', 'Saved successfully')
    },
    fetchFiles: (token, layerId) => async (dispatch, getState) => {
        dispatch(actions.setIsWaitingForFiles(true))
        const files = await dispatch(
            baseApi.endpoints.fetchSubmissionsDetails.initiate({
                token,
                layerId,
                includeAnon: getState().assignment.filters.type.anonymousSubmissions,
            }),
        ).unwrap()
        dispatch(actions.setAssignment({ ...getState().assignment.assignment, files }))
        dispatch(actions.setIsWaitingForFiles(false))
        return files
    },
    fetchPatterns: (token, layerId) => async (dispatch, getState) => {
        dispatch(actions.setIsWaitingForPatterns(true))
        const patterns = await handleErrors(async () => {
            let { data: patterns } = await AssignmentService.getLayerPatterns(token, layerId)
            patterns = patterns.map(pattern => ({
                ...pattern,
                query_stats: pattern.query_stats ? JSON.parse(pattern.query_stats) : null,
                criteria: pattern.type === PATTERN_TYPES.SEMANTIC.value ? JSON.parse(pattern.query) : null,
            }))
            if (patterns) {
                const patternFilters = patterns.map(pattern => ({
                    enabled: false,
                    show: true,
                    id: pattern.motif_id,
                    name: pattern.motif_caption,
                    colorId: pattern.color_id,
                    type: pattern.type,
                    expanded: false,
                    criteria:
                        pattern.type === PATTERN_TYPES.SEMANTIC.value && pattern.criteria
                            ? pattern.criteria.map((criterion, index) => ({
                                  id: index,
                                  text: criterion,
                                  enabled: false,
                                  show: true,
                              }))
                            : [],
                }))
                dispatch(actions.setPatternFilter(patternFilters))
            }
            if (getState().assignment.editingPattern) {
                dispatch(actions.setShowEditPatternModal(true))
            }
            dispatch(actions.setAssignment({ ...getState().assignment.assignment, patterns }))
            return patterns
        })
        dispatch(actions.setIsWaitingForPatterns(false))
        return patterns
    },
    fetchPatternsReport: (token, layerId) => async dispatch => {
        return await handleErrors(async () => {
            const response = await AssignmentService.getPatternsReport(token, layerId)
            dispatch(actions.setPatternsReportData(response.data))
        })
    },
    fetchLayers: token => async dispatch => {
        return await handleErrors(async () => {
            const response = await AssignmentService.getAssignmentLayers(token)
            dispatch(actions.setLayers(response.data))
        })
    },
    fetchVersions: token => async dispatch => {
        return await handleErrors(async () => {
            const response = await AssignmentService.getAssignmentVersions(token, false)
            dispatch(actions.setVersions(response.data))
        })
    },
    updateVersion: props => async (dispatch, getState) => {
        const { token, id, name, testsetPercentage, isDefault, isPublished } = props

        return await handleErrors(async () => {
            await AssignmentService.updateVersion(props)
            const _versions = _.cloneDeep(getState().assignment.versions)
            if (isDefault) _versions.map(version => (version.is_default = false))
            const versionToUpdate = _versions.find(version => version.id === id)
            versionToUpdate.name = name
            versionToUpdate.testset_percentage = testsetPercentage
            versionToUpdate.is_default = isDefault
            versionToUpdate.is_published = isPublished
            dispatch(actions.setVersions(_versions))
            dispatch(
                baseApi.util.invalidateTags([
                    { type: VERSION_TAG, id },
                    { type: VERSION_TAG, id: token },
                ]),
            )

            const assignment = _.cloneDeep(getState().assignment.assignment)
            assignment.current_version = {
                ...assignment.current_version,
                ...versionToUpdate,
            }
            dispatch(actions.setAssignment(assignment))
            dispatch(assignmentApi.util.invalidateTags([{ type: ASSIGNMENT_TAG, id: token }]))

            openNotificationWithIcon('success', 'Saved successfully')
            return true
        })
    },
    fetchPossibleToCopy: token => async () => {
        return await handleErrors(async () => {
            const { data: possibleToCopy } = await AssignmentService.getPossibleToCopy(token)
            return possibleToCopy
        })
    },
    fetchFileReasoning: (token, layerId, patternId) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const getFileReasoningResponse = await AssignmentService.getFileReasoning(
                token,
                layerId,
                getState().assignment.drawer.file.id,
                patternId,
            )
            return getFileReasoningResponse.data
        })
    },
    updateFileArchetype: (token, layerId, fileId, isArchetype) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const updateAssignmentFileResponse = await AssignmentService.updateAssignmentFile(
                token,
                layerId,
                fileId,
                isArchetype,
            )
            const _clusters = _.cloneDeep(getState().assignment.clusters)
            // const clusterToUpdate = _clusters.find(cluster => cluster.cluster_id === CLUSTER_X_ID)
            const fileToUpdate = _clusters
                .map(cluster => cluster.files)
                .flat()
                .find(file => file.id === fileId)
            fileToUpdate.is_archetype = isArchetype
            dispatch(actions.setClusters(_clusters))
            openNotificationWithIcon('success', 'Updated successfully')
            return updateAssignmentFileResponse.data
        })
    },
    setClusters: value => ({
        type: actionTypes.SET_CLUSTERS,
        payload: { value },
    }),
    setFilteredClusters: value => ({
        type: actionTypes.SET_FILTERED_CLUSTERS,
        payload: { value },
    }),
    setIncludeAnonSubmissionsFilter: value => ({
        type: actionTypes.SET_INCLUDE_ANON_SUBMISSIONS_FILTER,
        payload: { value },
    }),
    switchIncludeAnonSubmissionsFilter: (token, layerId) => async (dispatch, getState) => {
        getState().assignment.filters.type.anonymousSubmissions
            ? dispatch(actions.setIncludeAnonSubmissionsFilter(false))
            : dispatch(actions.setIncludeAnonSubmissionsFilter(true))
        dispatch(actions.fetchFiles(token, layerId))
        dispatch(actions.fetchClusters(token, layerId))
    },
    setExactMatch: value => ({
        type: actionTypes.SET_EXACT_MATCH,
        payload: { value },
    }),
    setPatternFilter: value => ({
        type: actionTypes.SET_PATTERN_FILTER,
        payload: { value },
    }),
    setPatternExpanded: (patternId, expanded) => ({
        type: actionTypes.SET_PATTERN_EXPANDED,
        payload: { patternId, expanded },
    }),
    setPatternCriteriaFilter: (patternId, criteriaId, enabled, show) => ({
        type: actionTypes.SET_PATTERN_CRITERIA_FILTER,
        payload: { patternId, criteriaId, enabled, show },
    }),
    setMissingPatternFeedbackFilter: value => ({
        type: actionTypes.SET_MISSING_PATTERN_FEEDBACK_FILTER,
        payload: { value },
    }),
    setMissingGroupFeedbackFilter: value => ({
        type: actionTypes.SET_MISSING_GROUP_FEEDBACK_FILTER,
        payload: { value },
    }),
    setIsFlakyFilter: value => ({
        type: actionTypes.SET_IS_FLAKY_FILTER,
        payload: { value },
    }),
    setReviewFilter: value => ({
        type: actionTypes.SET_REVIEW_FILTER,
        payload: { value },
    }),
    setUnitTestsFilter: value => ({
        type: actionTypes.SET_UNIT_TESTS_FILTER,
        payload: { value },
    }),
    selectSubgroupWithSamePatterns: (token, layerId) => async (dispatch, getState) => {
        dispatch(actions.setIsWaitingForSelectSubgroup(true))
        await handleErrors(async () => {
            const { data } = await AssignmentService.subgroup(
                token,
                layerId,
                getState().submission.selectedSubmissionIds,
            )
            dispatch(submissionActions.setSelectedSubmissionIds(data))
        })
        dispatch(actions.setIsWaitingForSelectSubgroup(false))
    },
    setIsWaitingForClusters: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_CLUSTERS,
        payload: { value },
    }),
    setIsWaitingForAssignmentInfo: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_ASSIGNMENT_INFO,
        payload: { value },
    }),
    setIsWaitingForFiles: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_FILES,
        payload: { value },
    }),
    setIsWaitingForPatterns: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_PATTERNS,
        payload: { value },
    }),
    setIsWaitingForSelectSubgroup: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_SELECT_SUBGROUP,
        payload: { value },
    }),
    fetchClusters: (token, layerId, navigate) => async (dispatch, getState) => {
        dispatch(actions.setIsWaitingForClusters(true))
        try {
            const getLayerClustersResponse = await AssignmentService.getLayerClusters(
                token,
                layerId,
                getState().assignment.filters.type.anonymousSubmissions,
            )
            dispatch(actions.setClusters(getLayerClustersResponse.data.clusters))

            if (isNumber(getLayerClustersResponse.data.new_pattern_id))
                dispatch(setPendingApprovalPatternId(getLayerClustersResponse.data.new_pattern_id))
        } catch (error) {
            if (error?.response?.status === 404) {
                const assignment = getState().assignment.assignment
                if (!_.isNil(assignment.current_version?.default_layer_id)) {
                    // if trying to access a non-existing layer switch to the default one
                    const path = window.location.pathname
                    const updatedPath = path.replace(
                        new RegExp(`${AssignmentSections.HOME}\\/\\d+`),
                        `${AssignmentSections.HOME}/${assignment.current_version?.default_layer_id}`,
                    )
                    const updatedUrl = updatedPath + window.location.search
                    if (navigate) navigate(updatedUrl, { replace: true })
                }
            } else if (error?.response) {
                openNotificationWithIcon('warning', error.response.data.detail)
            } else {
                console.log(error)
            }
        }
        dispatch(actions.setIsWaitingForClusters(false))
    },
    setLayers: value => ({
        type: actionTypes.SET_LAYERS,
        payload: { value },
    }),
    setVersions: value => ({
        type: actionTypes.SET_VERSIONS,
        payload: { value },
    }),
    createLayer: (token, layerName) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            await AssignmentService.createLayer(token, layerName)
            await dispatch(actions.fetchLayers(token))
            openNotificationWithIcon('success', 'Component created successfully')
            dispatch(actions.setPatternFilter([]))
            dispatch(baseApi.util.invalidateTags([{ type: COMPONENT_TAG, id: 'LIST' }]))
            return getState().assignment.layers.at(-1).layer_id
        })
    },
    deleteLayer: (token, layerId) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const layers = getState().assignment.layers
            const unitTestsLayer = getState().assignment.layers.filter(layer => layer.layer_name === 'UnitTests999')
            if ((layers.length === 1 && !unitTestsLayer) || (layers.length === 2 && unitTestsLayer)) {
                openNotificationWithIcon('warning', "Can't remove a single component")
                return
            }
            await AssignmentService.deleteLayer(token, layerId)
            const filteredLayers = getState().assignment.layers.filter(layer => layer.layer_id !== Number(layerId))
            openNotificationWithIcon('success', 'Component deleted successfully')
            dispatch(actions.setPatternFilter([]))
            dispatch(actions.setLayers(filteredLayers))
            dispatch(baseApi.util.invalidateTags([{ type: COMPONENT_TAG, id: 'LIST' }]))
            return filteredLayers.find(layer => layer.layer_name !== 'UnitTests999').layer_id
        })
    },
    resetLayer: (token, layerId) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const resetLayerResponse = await AssignmentService.resetLayer(token, layerId)
            dispatch(actions.setClusters(resetLayerResponse.data.clusters))

            dispatch(actions.setPatternFilter([]))
            dispatch(
                actions.setAssignment({
                    ...getState().assignment.assignment,
                    patterns: [],
                }),
            )
            dispatch(baseApi.util.invalidateTags([{ type: COMPONENT_TAG, id: 'LIST' }]))
            openNotificationWithIcon('success', 'Component reset successfully')
            return true
        })
    },
    copyLayer: (token, layerId) => async dispatch => {
        return await handleErrors(async () => {
            const copyLayerResponse = await AssignmentService.copyLayer(token, layerId)
            openNotificationWithIcon('success', 'Component copied successfully')
            dispatch(baseApi.util.invalidateTags([{ type: COMPONENT_TAG, id: 'LIST' }]))
            return copyLayerResponse.data
        })
    },
    setShowDrawer: value => ({
        type: actionTypes.SET_SHOW_DRAWER,
        payload: { value },
    }),
    setDrawerFile: value => ({
        type: actionTypes.SET_DRAWER_FILE,
        payload: { value },
    }),
    setQuery: value => ({
        type: actionTypes.SET_QUERY,
        payload: { value },
    }),
    setQueryToCompare: value => ({
        type: actionTypes.SET_QUERY_TO_COMPARE,
        payload: { value },
    }),
    setRegroup: () => ({
        type: actionTypes.SET_REGROUP,
    }),
    setShowQueryEditor: value => ({
        type: actionTypes.SET_SHOW_QUERY,
        payload: { value },
    }),
    setIdOfPatternToChange: value => ({
        type: actionTypes.SET_ID_OF_PATTERN_TO_CHANGE,
        payload: { value },
    }),
    runQuery: (token, layerId) => async (dispatch, getState) => {
        if (!getState().assignment.query) {
            openNotificationWithIcon('error', 'Query text is empty')
            return
        }
        dispatch(actions.setIsWaitingForClusters(true))
        const editingPatternId = getState().assignment.drawer.idOfPatternToChange
        await handleErrors(async () => {
            const getQueryMatchesResponse = await AssignmentService.getQueryMatches(
                token,
                layerId,
                [getState().assignment.query],
                getState().assignment.regroup,
                editingPatternId,
            )
            dispatch(actions.setClusters(getQueryMatchesResponse.data.clusters))
            const newPattern = getQueryMatchesResponse.data.pattern
            dispatch(setPendingApprovalPatternId(newPattern.id))
            if (newPattern && getState().assignment.drawer.idOfPatternToChange === null) {
                const _patterns = getState().assignment.assignment.patterns
                const patterns = [
                    ..._patterns,
                    {
                        motif_id: newPattern.id,
                        motif_caption: newPattern.id,
                        color_id: newPattern.id,
                        query: getState().assignment.query,
                        type: PATTERN_TYPES.QUERY.value,
                        groupingCap: GROUPING_CAP_TYPES.UNLIMITED.value,
                        warningLevel: PatternWarningLevels.NEUTRAL,
                    },
                ]
                dispatch(
                    actions.setAssignment({
                        ...getState().assignment.assignment,
                        patterns,
                    }),
                )
            } else if (isNumber(editingPatternId)) {
                const _patterns = getState().assignment.assignment.patterns
                const patterns = _patterns.map(pattern =>
                    pattern.motif_id === editingPatternId
                        ? { ...pattern, query: getState().assignment.query }
                        : pattern,
                )
                dispatch(actions.setAssignment({ ...getState().assignment.assignment, patterns }))
                dispatch(baseApi.util.invalidateTags([{ type: PATTERN_TAG, id: editingPatternId }]))
            }
        })
        dispatch(actions.setIsWaitingForClusters(false))
    },
    compareQueries: (token, layerId) => async (dispatch, getState) => {
        if (_.isNil(getState().assignment.queryToCompare.value)) {
            openNotificationWithIcon('error', 'Please, select a query to compare')
            return
        } else if (!getState().assignment.query) {
            openNotificationWithIcon('error', 'Query text is empty')
            return
        }
        dispatch(actions.setIsWaitingForClusters(true))
        await handleErrors(async () => {
            const compareQueriesResponse = await AssignmentService.compareQueries(
                token,
                layerId,
                getState().assignment.queryToCompare.value,
                getState().assignment.query,
            )

            dispatch(actions.setClusters(compareQueriesResponse.data.clusters))
            dispatch(actions.setQueryComparisonMode(true))
        })
        dispatch(actions.setIsWaitingForClusters(false))
    },
    setConfirmChangesMode: value => ({
        type: actionTypes.SET_CONFIRM_CHANGES_MODE,
        payload: { value },
    }),
    setQueryComparisonMode: value => ({
        type: actionTypes.SET_QUERY_COMPARISON_MODE,
        payload: { value },
    }),
    getFileXML: (token, fileId) => async () => {
        await handleErrors(async () => {
            AssignmentService.downloadFile(token, fileId, true)
        })
    },
    downloadFile: (token, fileId, fileName) => async () => {
        await handleErrors(async () => {
            await AssignmentService.downloadFile(token, fileId, false, fileName)
        })
    },
    setShowCreateVersionModal: value => ({
        type: actionTypes.SET_SHOW_CREATE_VERSION_MODAL,
        payload: { value },
    }),
    setShowAdvancedExportSubmissionsModal: value => ({
        type: actionTypes.SET_SHOW_ADVANCED_EXPORT_SUBMISSIONS_MODAL,
        payload: { value },
    }),
    setShowEditVersionModal: value => ({
        type: actionTypes.SET_SHOW_EDIT_VERSION_MODAL,
        payload: { value },
    }),
    setShowCreateComponentModal: value => ({
        type: actionTypes.SET_SHOW_CREATE_COMPONENT_MODAL,
        payload: { value },
    }),
    setShowEditComponentModal: value => ({
        type: actionTypes.SET_SHOW_EDIT_COMPONENT_MODAL,
        payload: { value },
    }),
    setShowDiscoveryModal: value => ({
        type: actionTypes.SET_SHOW_DISCOVERY_MODAL,
        payload: { value },
    }),
    setShowGradingModal: value => ({
        type: actionTypes.SET_SHOW_GRADING_MODAL,
        payload: { value },
    }),
    setShowEditPatternModal: value => ({
        type: actionTypes.SET_SHOW_EDIT_PATTERN_MODAL,
        payload: { value },
    }),
    setShowSemanticPatternModal: value => ({
        type: actionTypes.SET_SHOW_CREATE_SEMANTIC_PATTERN_MODAL,
        payload: { value },
    }),
    setShowSubmissionsSummaryModal: value => ({
        type: actionTypes.SET_SHOW_EXPORT_GRADES_MODAL,
        payload: { value },
    }),
    setShowMoveSelectedFilesToAnotherGroupModal: value => ({
        type: actionTypes.SET_SHOW_MOVE_SELECTED_FILES_TO_ANOTHER_GROUP_MODAL,
        payload: { value },
    }),
    setInitialState: value => ({
        type: actionTypes.SET_INITIAL_STATE,
        payload: { value },
    }),
    deletePattern: (token, layerId, id) => async dispatch => {
        return await handleErrors(async () => {
            const deletePatternResponse = await AssignmentService.deletePattern(token, layerId, id)
            dispatch(actions.setClusters(deletePatternResponse.data))
            dispatch(actions.setShowEditPatternModal(false))
            dispatch(actions.setEditingPattern(null))
            dispatch(actions.setShowDrawer(false))
            dispatch(actions.fetchPatterns(token, layerId))
            openNotificationWithIcon('success', 'Pattern was deleted successfully')
            dispatch(baseApi.util.invalidateTags([{ type: PATTERN_TAG, id }]))
            return true
        })
    },
    regroup:
        (token, layerId, oldGroupingCap = undefined) =>
        async (dispatch, getState) => {
            dispatch(actions.setIsWaitingForClusters(true))
            const regroupedClusters = await handleErrors(async () => {
                const oldPattern = getState().assignment.assignment.patterns?.find(
                    motif => motif.motif_id === getState().assignment.editingPattern?.id,
                )

                // Only add oldPatternToCap if oldGroupingCap is provided
                const oldPatternToCap =
                    oldGroupingCap !== undefined ? { [oldPattern.motif_id]: oldGroupingCap } : undefined

                const regroupResponse = await AssignmentService.regroup(token, layerId, oldPatternToCap)
                const regroupedClusters = regroupResponse.data
                dispatch(actions.setClusters(regroupedClusters))
                return regroupedClusters
            })
            dispatch(actions.setIsWaitingForClusters(false))
            return regroupedClusters
        },
    updatePattern:
        (
            token,
            layerId,
            id,
            name,
            feedback,
            description,
            grade,
            colorId,
            groupingCap,
            warningLevel,
            conceptualLabels,
            patternType,
            hitFeedback,
            missFeedback,
            showHitReasoning,
            showMissReasoning,
            criteria,
            oldGroupingCap,
        ) =>
        async (dispatch, getState) => {
            return await handleErrors(async () => {
                const assignment = _.cloneDeep(getState().assignment.assignment)
                let clusters = _.cloneDeep(getState().assignment.clusters)

                await AssignmentService.updatePattern(
                    token,
                    layerId,
                    id,
                    name,
                    feedback,
                    description,
                    grade,
                    colorId,
                    groupingCap,
                    warningLevel,
                    conceptualLabels,
                    patternType,
                    hitFeedback,
                    missFeedback,
                    showHitReasoning,
                    showMissReasoning,
                )

                assignment.patterns = assignment.patterns.map(motif => {
                    if (motif.motif_id === id) {
                        // For semantic patterns, store the feedback in the expected format
                        let updatedFeedback = feedback
                        if (patternType === PATTERN_TYPES.SEMANTIC.value) {
                            updatedFeedback = JSON.stringify({
                                hit_feedback: hitFeedback || '',
                                miss_feedback: missFeedback || '',
                                show_hit_reasoning: showHitReasoning || false,
                                show_miss_reasoning: showMissReasoning || false,
                            })
                        }

                        return {
                            ...motif,
                            description: description,
                            feedback: updatedFeedback,
                            grade: grade,
                            motif_id: id,
                            motif_caption: name,
                            color_id: colorId,
                            grouping_cap: groupingCap,
                            warning_level: warningLevel,
                            conceptual_labels: conceptualLabels,
                        }
                    }
                    return motif
                })

                if (criteria) {
                    const updatePatternCriteriaAndProjectResponse =
                        await AssignmentService.updatePatternCriteriaAndProject(
                            token,
                            layerId,
                            id,
                            criteria,
                            true,
                            oldGroupingCap,
                        )
                    dispatch(
                        actions.setAssignment({
                            ...getState().assignment.assignment,
                            current_version: {
                                ...getState().assignment.assignment.current_version,
                                processing_status: ASSIGNMENT_PROCESSING_STATUSES.PROJECTION,
                                processing_msg: 'Projecting semantic pattern',
                                processing_progress: 0,
                            },
                        }),
                    )
                    clusters = updatePatternCriteriaAndProjectResponse.data.clusters
                    assignment.patterns = assignment.patterns.map(motif =>
                        motif.motif_id === id ? { ...motif, query: JSON.stringify(criteria) } : motif,
                    )
                    return true
                } else {
                    clusters = clusters.map(item => {
                        const updatedFiles = item.files.map(file => {
                            const updatedMotifList = file.motifList.map(motif => {
                                if (motif.motif_id === id) {
                                    return { ...motif, color_id: colorId }
                                }
                                return motif
                            })
                            return { ...file, motifList: updatedMotifList }
                        })
                        return { ...item, files: updatedFiles }
                    })
                }

                dispatch(actions.setClusters(clusters))

                dispatch(actions.setAssignment({ ...assignment }))

                const _patternFilters = _.cloneDeep(getState().assignment.filters.patterns)
                const patternFilterToUpdate = _patternFilters.find(pattern => pattern.id === id)
                if (patternFilterToUpdate) {
                    patternFilterToUpdate.name = name
                    patternFilterToUpdate.colorId = colorId
                }
                dispatch(actions.setPatternFilter(_patternFilters))
                dispatch(baseApi.util.invalidateTags([{ type: PATTERN_TAG, id }]))
                return true
            })
        },
    runArchetypeDiscovery: (token, layerId) => async dispatch => {
        const discoverySucceed = await handleErrors(async () => {
            await AssignmentService.runArchetypeDiscovery(token, layerId)
            dispatch(actions.fetchClusters(token, layerId))
            return true
        })
        dispatch(actions.setShowDiscoveryModal(false))
        return discoverySucceed
    },
    saveClusterFeedback:
        (token, layerId, id, name, feedback, grade, conceptualLabels) => async (dispatch, getState) => {
            return await handleErrors(async () => {
                await AssignmentService.updateCluster(token, layerId, id, name, feedback, grade, conceptualLabels)
                const _clusters = _.cloneDeep(getState().assignment.clusters)
                const clusterToUpdate = _clusters.find(cluster => cluster.cluster_id === id)
                clusterToUpdate.cluster_name = name
                clusterToUpdate.feedback = feedback
                clusterToUpdate.grade = grade
                clusterToUpdate.conceptual_labels = conceptualLabels
                dispatch(actions.setClusters(_clusters))
                dispatch(baseApi.util.invalidateTags([{ type: GROUP_TAG, id: 'LIST' }]))
                openNotificationWithIcon('success', 'Saved successfully')
            })
        },
    saveComponent: (token, layerId, layerName) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            await AssignmentService.updateComponent(token, layerId, layerName)
            const _layers = [...getState().assignment.layers]
            const layerToUpdate = _layers.find(cluster => cluster.layer_id === layerId)
            layerToUpdate.layer_name = layerName
            dispatch(actions.setLayers(_layers))
            dispatch(baseApi.util.invalidateTags([{ type: COMPONENT_TAG, id: 'LIST' }]))
            openNotificationWithIcon('success', 'Saved successfully')
        })
    },
    updateGrading: (token, layers) => async dispatch => {
        return await handleErrors(async () => {
            const updateGradingResponse = await AssignmentService.updateGrading(token, layers)
            dispatch(actions.setLayers(updateGradingResponse.data))
            dispatch(baseApi.util.invalidateTags([{ type: COMPONENT_TAG, id: 'LIST' }]))
            openNotificationWithIcon('success', 'Saved successfully')
            dispatch(actions.setShowGradingModal(false))
        })
    },
    updateFileGrading: (token, layerId, fileId, feedback, grade) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const response = await AssignmentService.updateFileGrading(token, layerId, fileId, feedback, grade)
            const _clusters = _.cloneDeep(getState().assignment.clusters)
            const clusterToUpdate = _clusters.find(cluster => cluster.cluster_id === CLUSTER_X_ID)
            const fileToUpdate = clusterToUpdate.files.find(file => file.id === fileId)
            fileToUpdate.feedback = feedback
            fileToUpdate.file_grade = grade
            fileToUpdate.total_grade = response.data.total_grade
            dispatch(actions.setClusters(_clusters))
            openNotificationWithIcon('success', 'Saved successfully')
            return true
        })
    },
    setPatternsReportData: value => ({
        type: actionTypes.SET_PATTERNS_REPORT_DATA,
        payload: { value },
    }),
    setGroupsUnitTestsReportData: value => ({
        type: actionTypes.SET_GROUPS_UNIT_TESTS_REPORT_DATA,
        payload: { value },
    }),
    fetchGroupsUnitTestsReportData: token => async dispatch => {
        return await handleErrors(async () => {
            const getLayerClustersResponse = await AssignmentService.getGroupsUnitTestsReport(token)
            dispatch(actions.setGroupsUnitTestsReportData(getLayerClustersResponse.data))
        })
    },
    setAssignmentHideGrading: value => ({
        type: actionTypes.SET_ASSIGNMENT_HIDE_GRADING,
        payload: { value },
    }),
    updateHideGrading: (token, hideGrading) => async dispatch => {
        return await handleErrors(async () => {
            await AssignmentsService.updateHideGrading(token, hideGrading)
            dispatch(actions.setAssignmentHideGrading(Number(hideGrading)))
            openNotificationWithIcon('success', 'Updated successfully')
        })
    },
    fetchUnitTestResults: token => async dispatch => {
        dispatch(actions.setIsWaitingForUnitTestResults(true))
        await handleErrors(async () => {
            const getUnitTestResultsResponse = await AssignmentService.getUnitTestResults(token)
            dispatch(actions.setUnitTestResults(getUnitTestResultsResponse.data.ut_results))
            dispatch(actions.setUnitTests(getUnitTestResultsResponse.data.uts_definition))
            dispatch(
                actions.setUnitTestsFilter(
                    getUnitTestResultsResponse.data.uts_definition.map(ut => ({
                        enabled: false,
                        passed: true,
                        ...ut,
                    })),
                ),
            )
        })
        dispatch(actions.setIsWaitingForUnitTestResults(false))
    },
    setUnitTests: value => ({
        type: actionTypes.SET_UNIT_TESTS,
        payload: { value },
    }),
    setUnitTestResults: value => ({
        type: actionTypes.SET_UNIT_TEST_RESULTS,
        payload: { value },
    }),
    setIsWaitingForUnitTestResults: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_UNIT_TEST_RESULTS,
        payload: { value },
    }),
    setEditingPattern: value => ({
        type: actionTypes.SET_EDITING_PATTERN,
        payload: { value },
    }),
    setSemanticPatternDetails: value => ({
        type: actionTypes.SET_SEMANTIC_PATTERN_DETAILS,
        payload: { value },
    }),
    setColorIdOfCreatedSemanticPatternDetails: value => ({
        type: actionTypes.SET_COLOR_ID_OF_CREATED_SEMANTIC_PATTERN_DETAILS,
        payload: { value },
    }),
    setDescriptionsSuggestedBySemanticDiscovery: value => ({
        type: actionTypes.SET_DESCRIPTIONS_SUGGESTED_BY_SEMANTIC_DISCOVERY,
        payload: { value },
    }),
    switchClusterCollapse: value => ({
        type: actionTypes.SWITCH_CLUSTER_COLLAPSE,
        payload: { value },
    }),
    switchAllClustersCollapse: value => ({
        type: actionTypes.SWITCH_ALL_CLUSTERS_COLLAPSE,
        payload: { value },
    }),
    isExcelAssignment: () => (dispatch, getState) => {
        return (
            isExcelAssignment(getState().assignment.assignment.language) || _.isEmpty(getState().assignment.assignment)
        )
    },
    generateAndProjectCriteria:
        (token, layerId, description, llmVersion = LLM_VERSIONS.FAST.value) =>
        async (dispatch, getState) => {
            return await handleErrors(async () => {
                const generateAndProjectCriteriaResponse = await AssignmentService.generateAndProjectCriteria(
                    token,
                    layerId,
                    description,
                    getState().assignment.drawer.file.id,
                    llmVersion,
                )
                dispatch(
                    actions.setSemanticPatternDetails({
                        id: generateAndProjectCriteriaResponse.data.id,
                        name: generateAndProjectCriteriaResponse.data.name,
                        feedback: generateAndProjectCriteriaResponse.data.feedback,
                        description,
                        projection: generateAndProjectCriteriaResponse.data.projection,
                        colorId: generateAndProjectCriteriaResponse.data.id,
                        llmVersion,
                    }),
                )
                return generateAndProjectCriteriaResponse.data
            })
        },
    regenerateAndProjectCriteria: (token, layerId, description) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const generateAndProjectCriteriaResponse = await AssignmentService.generateAndProjectCriteria(
                token,
                layerId,
                description,
                getState().assignment.drawer.file.id,
                getState().assignment.semanticPatternDetails?.llmVersion,
            )
            dispatch(
                actions.setSemanticPatternDetails({
                    id: generateAndProjectCriteriaResponse.data.id,
                    name: generateAndProjectCriteriaResponse.data.name,
                    feedback: generateAndProjectCriteriaResponse.data.feedback,
                    description,
                    projection: generateAndProjectCriteriaResponse.data.projection,
                    colorId: getState().assignment.semanticPatternDetails.colorId,
                    llmVersion: getState().assignment.semanticPatternDetails.llmVersion || LLM_VERSIONS.FAST.value,
                }),
            )
            return generateAndProjectCriteriaResponse.data
        })
    },
    regenerateCriteria: (token, feedback) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const generateCriteriaResponse = await AssignmentService.generateCriteria(
                token,
                feedback,
                getState().assignment.semanticPatternDetails?.llmVersion,
            )
            return generateCriteriaResponse.data.criteria
        })
    },
    projectCriteria:
        (token, criteria, saveInStore = true, llmVersion, submissionId, layerId, patternId) =>
        async (dispatch, getState) => {
            return await handleErrors(async () => {
                const projectCriteriaResponse = await AssignmentService.projectCriteria(
                    token,
                    criteria,
                    submissionId ?? getState().assignment.drawer.file.id,
                    llmVersion ?? getState().assignment.semanticPatternDetails?.llmVersion,
                    layerId,
                    patternId,
                )
                if (saveInStore) {
                    const semanticPatternDetails = _.cloneDeep(getState().assignment.semanticPatternDetails)
                    semanticPatternDetails.projection = projectCriteriaResponse.data.projection[0].map(p => ({
                        ...p,
                        visible: true,
                    }))
                    dispatch(actions.setSemanticPatternDetails(semanticPatternDetails))
                }
                return projectCriteriaResponse.data.projection[0]
            })
        },
    estimateProjectionCost: (token, criteria, setResponseMessage, llmVersion) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const estimateProjectionCostResponse = await AssignmentService.estimateProjectionCost(
                token,
                criteria,
                llmVersion || getState().assignment.semanticPatternDetails?.llmVersion,
            )
            return estimateProjectionCostResponse.data.cost
        }, setResponseMessage)
    },
    estimateDiscoveryCost: (token, setResponseMessage) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const estimateDiscoveryCostResponse = await AssignmentService.estimateDiscoveryCost(
                token,
                getState().assignment.semanticPatternDetails?.llmVersion,
            )
            return estimateDiscoveryCostResponse.data.cost
        }, setResponseMessage)
    },
    createSemanticPattern:
        (
            token,
            layerId,
            name,
            feedback,
            description,
            criteria,
            grade,
            colorId,
            groupingCap,
            regroup,
            hitFeedback,
            missFeedback,
            showHitReasoning,
            showMissReasoning,
            warningLevel,
            conceptualLabels,
        ) =>
        async (dispatch, getState) => {
            return await handleErrors(async () => {
                await AssignmentService.createSemanticPattern(
                    token,
                    layerId,
                    getState().assignment.drawer.file.id,
                    name,
                    feedback,
                    description,
                    criteria,
                    grade,
                    colorId,
                    groupingCap,
                    regroup,
                    hitFeedback,
                    missFeedback,
                    showHitReasoning,
                    showMissReasoning,
                    getState().assignment.semanticPatternDetails?.llmVersion,
                    warningLevel,
                    conceptualLabels,
                )
                dispatch(actions.setShowSemanticPatternModal(false))
                dispatch(
                    actions.setAssignment({
                        ...getState().assignment.assignment,
                        current_version: {
                            ...getState().assignment.assignment.current_version,
                            processing_status: ASSIGNMENT_PROCESSING_STATUSES.PROJECTION,
                            processing_msg: 'Projecting semantic pattern',
                            processing_progress: 0,
                        },
                    }),
                )
            })
        },
    runSemanticDiscovery: (token, layerId, type, disciplines) => async dispatch => {
        return await handleErrors(async () => {
            // Start the discovery process in the background
            await AssignmentService.runSemanticDiscovery(token, layerId, type, disciplines)

            // Close the discovery modal and fetch assignment info to show processing status
            dispatch(actions.setShowDiscoveryModal(false))
            dispatch(actions.fetchAssignmentInfo(token))
            dispatch(baseApi.util.invalidateTags([{ type: CONCEPTUAL_LABEL_TAG, id: 'DISCOVERY' }]))

            return true
        })
    },
    createSemanticPatterns: (token, layerId, patternIds) => async dispatch => {
        return await handleErrors(async () => {
            // Then project all patterns at once
            await dispatch(
                baseApi.endpoints.projectConceptualLabelDiscovery.initiate({
                    layerId,
                    patternIds,
                }),
            )

            dispatch(actions.setShowDiscoveryModal(false))
            await dispatch(actions.fetchAssignmentInfo(token))

            // Invalidate cache tags
            dispatch(baseApi.util.invalidateTags([{ type: PATTERN_TAG, id: 'LIST' }]))

            return true
        })
    },
}

/******************************************* REDUCER ************************************************/
const assignmentReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_ASSIGNMENT:
            const patterns = action.payload.value.patterns
            const areOldAndNewPatternsTheSame = _.isEqual(state.assignment.patterns, patterns)
            let patternFilters = state.filters.patterns
            if (patterns && !areOldAndNewPatternsTheSame)
                patternFilters = patterns?.map(pattern => ({
                    enabled: false,
                    show: true,
                    id: pattern.motif_id,
                    name: pattern.motif_caption,
                    colorId: pattern.color_id,
                    type: pattern.type,
                }))
            return {
                ...state,
                assignment: action.payload.value,
                //filters: { ...state.filters, patterns: patternFilters },
            }

        case actionTypes.SET_CLUSTERS:
            const _clusters = [...action.payload.value]
            const indexOfClusterX = _clusters.findIndex(cluster => cluster.cluster_id === CLUSTER_X_ID)
            const clusterX = _clusters.splice(indexOfClusterX, 1)[0]
            const indexOfClusterY = _clusters.findIndex(cluster => cluster.cluster_id === CLUSTER_Y_ID)
            const clusterY = _clusters.splice(indexOfClusterY, 1)[0]

            return {
                ...state,
                clusters: [..._clusters, clusterX, clusterY],
            }

        case actionTypes.SET_FILTERED_CLUSTERS:
            return {
                ...state,
                filteredClusters: action.payload.value,
            }

        case actionTypes.SET_INCLUDE_ANON_SUBMISSIONS_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    type: {
                        ...state.filters.type,
                        anonymousSubmissions: action.payload.value,
                    },
                },
            }

        case actionTypes.SET_EXACT_MATCH:
            return {
                ...state,
                filters: { ...state.filters, exactMatch: action.payload.value },
            }

        case actionTypes.SET_PATTERN_FILTER:
            return {
                ...state,
                filters: { ...state.filters, patterns: [...action.payload.value] },
            }

        case actionTypes.SET_MISSING_PATTERN_FEEDBACK_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    feedback: {
                        ...state.filters.feedback,
                        missingPatternFeedback: action.payload.value,
                    },
                },
            }

        case actionTypes.SET_MISSING_GROUP_FEEDBACK_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    feedback: {
                        ...state.filters.feedback,
                        missingGroupFeedback: action.payload.value,
                    },
                },
            }

        case actionTypes.SET_IS_FLAKY_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    properties: {
                        ...state.filters.properties,
                        isFlaky: action.payload.value,
                    },
                },
            }

        case actionTypes.SET_REVIEW_FILTER:
            return {
                ...state,
                filters: { ...state.filters, review: action.payload.value },
            }

        case actionTypes.SET_UNIT_TESTS_FILTER:
            return {
                ...state,
                filters: { ...state.filters, unitTests: action.payload.value },
            }

        case actionTypes.SET_IS_WAITING_FOR_CLUSTERS:
            return {
                ...state,
                isWaitingForClusters: action.payload.value,
            }

        case actionTypes.SET_IS_WAITING_FOR_ASSIGNMENT_INFO:
            return {
                ...state,
                isWaitingForAssignmentInfo: action.payload.value,
            }

        case actionTypes.SET_IS_WAITING_FOR_FILES:
            return {
                ...state,
                isWaitingForFiles: action.payload.value,
            }

        case actionTypes.SET_IS_WAITING_FOR_PATTERNS:
            return {
                ...state,
                isWaitingForPatterns: action.payload.value,
            }

        case actionTypes.SET_IS_WAITING_FOR_SELECT_SUBGROUP:
            return {
                ...state,
                isWaitingForSelectSubgroup: action.payload.value,
            }

        case actionTypes.SET_LAYERS:
            return {
                ...state,
                layers: action.payload.value,
            }

        case actionTypes.SET_VERSIONS:
            return {
                ...state,
                versions: action.payload.value,
            }

        case actionTypes.SET_SHOW_DRAWER:
            return {
                ...state,
                drawer: { ...state.drawer, showDrawer: action.payload.value },
            }

        case actionTypes.SET_DRAWER_FILE:
            let content
            if (action.payload.value?.content) {
                content = action.payload.value.content
            } else if (action.payload.value.id !== undefined) {
                content = state.assignment.files[action.payload.value.id]?.content
            }

            return {
                ...state,
                drawer: {
                    ...state.drawer,
                    file: {
                        ...action.payload.value,
                        content: content,
                    },
                },
            }

        case actionTypes.SET_QUERY:
            return {
                ...state,
                query: action.payload.value,
            }

        case actionTypes.SET_QUERY_TO_COMPARE:
            return {
                ...state,
                queryToCompare: action.payload.value,
            }

        case actionTypes.SET_REGROUP:
            return {
                ...state,
                regroup: !state.regroup,
            }

        case actionTypes.SET_SHOW_QUERY:
            return {
                ...state,
                drawer: {
                    ...state.drawer,
                    showQueryEditor: action.payload.value,
                },
            }

        case actionTypes.SET_ID_OF_PATTERN_TO_CHANGE:
            return {
                ...state,
                drawer: {
                    ...state.drawer,
                    idOfPatternToChange: action.payload.value,
                },
            }

        case actionTypes.SET_CONFIRM_CHANGES_MODE:
            return {
                ...state,
                confirmChangesMode: action.payload.value,
            }

        case actionTypes.SET_QUERY_COMPARISON_MODE:
            return {
                ...state,
                queryComparisonMode: action.payload.value,
            }

        case actionTypes.SET_SHOW_CREATE_VERSION_MODAL:
            return {
                ...state,
                showCreateVersionModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_ADVANCED_EXPORT_SUBMISSIONS_MODAL:
            return {
                ...state,
                showAdvancedExportSubmissionsModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_EDIT_VERSION_MODAL:
            return {
                ...state,
                showEditVersionModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_CREATE_COMPONENT_MODAL:
            return {
                ...state,
                showCreateComponentModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_EDIT_COMPONENT_MODAL:
            return {
                ...state,
                showEditComponentModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_DISCOVERY_MODAL:
            return {
                ...state,
                showDiscoveryModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_GRADING_MODAL:
            return {
                ...state,
                showGradingModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_EDIT_PATTERN_MODAL:
            return {
                ...state,
                showEditPatternModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_CREATE_SEMANTIC_PATTERN_MODAL:
            return {
                ...state,
                showCreateSemanticPatternModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_EXPORT_GRADES_MODAL:
            return {
                ...state,
                showSubmissionsSummaryModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_MOVE_SELECTED_FILES_TO_ANOTHER_GROUP_MODAL:
            return {
                ...state,
                showMoveSelectedFilesToAnotherGroupModal: action.payload.value,
            }

        case actionTypes.SET_PATTERNS_REPORT_DATA:
            return {
                ...state,
                patternsReportData: action.payload.value,
            }

        case actionTypes.SET_GROUPS_UNIT_TESTS_REPORT_DATA:
            return {
                ...state,
                groupsUnitTestsReportData: action.payload.value,
            }

        case actionTypes.SET_ASSIGNMENT_HIDE_GRADING:
            return {
                ...state,
                assignment: {
                    ...state.assignment,
                    hide_grading: action.payload.value,
                },
            }

        case actionTypes.SET_UNIT_TESTS:
            return {
                ...state,
                unitTests: action.payload.value,
            }

        case actionTypes.SET_UNIT_TEST_RESULTS:
            return {
                ...state,
                unitTestResults: action.payload.value,
            }

        case actionTypes.SET_IS_WAITING_FOR_UNIT_TEST_RESULTS:
            return {
                ...state,
                isWaitingForUnitTestResults: action.payload.value,
            }

        case actionTypes.SET_EDITING_PATTERN:
            return {
                ...state,
                editingPattern: action.payload.value,
            }

        case actionTypes.SET_SEMANTIC_PATTERN_DETAILS:
            return {
                ...state,
                semanticPatternDetails: action.payload.value,
            }

        case actionTypes.SET_COLOR_ID_OF_CREATED_SEMANTIC_PATTERN_DETAILS:
            return {
                ...state,
                semanticPatternDetails: {
                    ...state.semanticPatternDetails,
                    colorId: action.payload.value,
                },
            }

        case actionTypes.SET_DESCRIPTIONS_SUGGESTED_BY_SEMANTIC_DISCOVERY:
            return {
                ...state,
                descriptionsSuggestedBySemanticDiscovery: action.payload.value,
            }

        case actionTypes.SWITCH_CLUSTER_COLLAPSE:
            let newCollapsedClusterIds1 = _.cloneDeep(state.collapsedClusterIds)
            if (state.collapsedClusterIds.includes(action.payload.value)) {
                newCollapsedClusterIds1 = newCollapsedClusterIds1.filter(id => id !== action.payload.value)
            } else {
                newCollapsedClusterIds1.push(action.payload.value)
            }

            return {
                ...state,
                collapsedClusterIds: newCollapsedClusterIds1,
            }

        case actionTypes.SWITCH_ALL_CLUSTERS_COLLAPSE:
            let newCollapsedClusterIds2 = _.cloneDeep(state.collapsedClusterIds)
            if (state.collapsedClusterIds.length) {
                newCollapsedClusterIds2 = []
            } else {
                newCollapsedClusterIds2 = state.clusters.map(cluster => cluster.cluster_id)
            }

            return {
                ...state,
                collapsedClusterIds: newCollapsedClusterIds2,
            }

        case actionTypes.SET_PATTERN_CRITERIA_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    patterns: state.filters.patterns.map(pattern => {
                        if (pattern.id === action.payload.patternId) {
                            const updatedCriteria = pattern.criteria.map((criterion, index) => {
                                if (index === action.payload.criteriaId) {
                                    return {
                                        ...criterion,
                                        enabled:
                                            action.payload.enabled !== undefined
                                                ? action.payload.enabled
                                                : criterion.enabled,
                                        show: action.payload.show !== undefined ? action.payload.show : criterion.show,
                                    }
                                }
                                return criterion
                            })
                            return { ...pattern, criteria: updatedCriteria }
                        }
                        return pattern
                    }),
                },
            }

        case actionTypes.SET_PATTERN_EXPANDED:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    patterns: state.filters.patterns.map(pattern => {
                        if (pattern.id === action.payload.patternId) {
                            return { ...pattern, expanded: action.payload.expanded }
                        }
                        return pattern
                    }),
                },
            }

        case actionTypes.SET_INITIAL_STATE:
            return INITIAL_STATE

        default:
            return state
    }
}

export default assignmentReducer
